// @flow
import React from 'react';

import SimilarContentCard from 'containers/fragments/card/SimilarContentCardContainer';
import type { SimilarContentType } from 'types/Article';

type Props = {
  similarContent: SimilarContentType[]
};

function SimilarContent({ similarContent }: Props) {
  if (!similarContent.length) {
    return null;
  }

  return (
    <>
      <h3 className="mt-md-3 mt-lg-5 mb-3 ft-400">Contenu similaire</h3>
      <div className="news-slider">
        <div className="news-slider__wrapper">
          {similarContent.map(post => (
            <SimilarContentCard key={post.id} content={post} />
          ))}
        </div>
      </div>
    </>
  );
}

export default SimilarContent;
